import React, { useState, useEffect } from 'react';
import { Input, Button } from 'antd';
import styled from 'styled-components';

const FullScreenContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: black;
  color: white;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
`;

export function Password(props) {
  const [inputValue, setInputValue] = useState('');
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check local storage for the password
    const storedPassword = localStorage.getItem('password');
    if (storedPassword) {
      setIsVisible(false);
    }
  }, []);

  const handleSubmit = () => {
    if (inputValue === '1997') {
      localStorage.setItem('password', '1997');
      setIsVisible(false);
    }
  };

  if (!isVisible) {
    return null; // Do not render anything if not visible
  }

  return (
    <FullScreenContainer className='_fcc _fv _fgap2'
    >
      <h1>Password</h1>


      <div className="_f">
        <Input
          type="password"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Enter password"
          size="large"
          style={{
            borderRadius: '1px',
            width: '200px',
            marginBottom: '20px',
            backgroundColor: 'white',
            color: 'black'
          }}
        />
        <Button
          type="primary"
          size="large"
          onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </FullScreenContainer>
  );
}
